import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useUserAccessStats = () => {
  return trpc.admin.getUserAccessStats.useQuery(undefined, {
    retry: false,
    cacheTime: CACHE_TIME,
    staleTime: STALE_TIME,
  });
};
